import React from 'react';
import { Users, Lightbulb, Bot, Video, Calendar, FileText, UserPlus, Globe } from 'lucide-react';
export const MembershipBenefits = () => {
  const benefits = [{
    title: 'Mastermind Sessions',
    description: 'Live idea feedback & strategy polishing',
    icon: <Lightbulb size={24} data-id="element-481" />
  }, {
    title: 'Project Handholding',
    description: 'Step-by-step guidance',
    icon: <Users size={24} data-id="element-482" />
  }, {
    title: 'AI Tools Catalogue',
    description: 'Curated tools + playbooks',
    icon: <Bot size={24} data-id="element-483" />
  }, {
    title: 'Virtual Networking Salons',
    description: 'Free & unlimited for members',
    icon: <Video size={24} data-id="element-484" />
  }, {
    title: 'Discounted Access to Live Events',
    description: 'Special pricing for Inner Circle members',
    icon: <Calendar size={24} data-id="element-485" />
  }, {
    title: 'Exclusive Resource Hub',
    description: 'Templates & toolkits',
    icon: <FileText size={24} data-id="element-486" />
  }, {
    title: 'Mentorship & Expert Access',
    description: 'Group coaching & hot-seat sessions',
    icon: <UserPlus size={24} data-id="element-487" />
  }, {
    title: 'Visibility & Collaboration Opportunities',
    description: 'Connect with other members',
    icon: <Globe size={24} data-id="element-488" />
  }];
  return <section className="py-16 border-b border-gray-200" data-id="element-489">
      <div className="container mx-auto px-4" data-id="element-490">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-12" data-id="element-491">
          Membership Benefits
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-492">
          {benefits.map((benefit, index) => <div key={index} className="border-2 border-gray-300 rounded-lg p-6 flex flex-col items-center text-center" data-id="element-493">
              <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mb-4" data-id="element-494">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-495">
                {benefit.title}
              </h3>
              <p className="text-gray-600" data-id="element-496">{benefit.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
};